import React from "react";
import { Tabs, Tab, Box, Typography, Card } from "@mui/material";
import { FaTools } from "react-icons/fa"; // React Icon for facility services

const sections = [
    "Summary",
    "Course Overview",
    "Qualification",
    "Description",
    "Suitable For",
    "Career Path",
    "Review"
];

export default function FacilitiesManagementOverview() {
    const [activeTab, setActiveTab] = React.useState(0);

    const handleChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    const tabContent = [
        <Typography>
            <div style={{ fontWeight: "700" }}>Summary</div>
            The Facilities Management course is designed to provide learners with the essential skills required to manage buildings, infrastructure, and support services efficiently. It covers technical operations, workplace safety, and maintenance strategies in a modern facility setting.
        </Typography>,
        <Typography>
            <div style={{ fontWeight: "700" }}>Course Overview</div>
            Learners will understand the roles of facilities managers, including overseeing building systems, compliance, sustainability practices, and vendor coordination. Topics include workplace optimization, asset tracking, and service delivery models.
        </Typography>,
        <Typography>
            <div style={{ fontWeight: "700" }}>Qualification</div>
            On completion, candidates receive a Level 3 Certificate in Facilities Management Practice, which supports entry into supervisory roles and meets professional standards outlined by institutions such as IWFM.
        </Typography>,
        <Typography>
            <div style={{ fontWeight: "700" }}>Description</div>
            Modules span maintenance planning, fire safety, HVAC management, budgeting, and sustainability audits. The course is offered as a flexible program over 6–8 weeks, with both instructor-led and online self-study formats.
        </Typography>,
        <Typography>
            <div style={{ fontWeight: "700" }}>Suitable For</div>
            Ideal for individuals seeking careers in property maintenance, office coordination, operations management, and facility support. No prior experience is required, though basic organizational skills are helpful.
        </Typography>,
        <Typography>
            <div style={{ fontWeight: "700" }}>Career Path</div>
            Graduates can pursue roles such as Facilities Coordinator, Maintenance Supervisor, Estate Manager, or Building Services Technician. With experience, opportunities expand into compliance, workplace strategy, and sustainability leadership.
        </Typography>,
        <Typography>
            <div style={{ fontWeight: "700" }}>Review</div>
            Learners appreciate the blend of practical insight and technical knowledge, especially in safety and planning. Feedback highlights instructor guidance, case studies, and real-world facility scenarios that build confidence.
        </Typography>
    ];

    return (
        <Box
            sx={{
                padding: "2rem",
                maxWidth: "900px",
                margin: "auto",
                borderRadius: "12px",
                fontFamily: "Segoe UI",
            }}
        >
            <Card sx={{ padding: "2rem",height:"50vh",  boxShadow: 4,borderTop:"4px solid goldenrod ", borderRadius: "12px" }}>
                <Typography variant="h6" style={{ fontWeight: "400", textAlign:"center", color: "#09122C" }}>
                        Facilities Management Course Overview
                    </Typography>

                <br />

                <Tabs
                    value={activeTab}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                    aria-label="Facilities Management Tabs"
                    sx={{
                        "& .MuiTab-root": {
                            fontWeight: "bold",
                            fontSize: "1rem",
                            width: "fit-content",
                            transition: "all 0.3s ease",
                            textTransform: "none",
                            color: "#09122C",
                        },
                        "& .MuiTab-root:hover": {
                            backgroundColor: "#09122C",
                            color: "goldenrod",
                            borderRadius: "8px 8px 0 0",
                        },
                    }}
                >
                    {sections.map((label, index) => (
                        <Tab key={index} label={label} />
                    ))}
                </Tabs>

                <Box sx={{ padding: "1.5rem", fontSize: "1.05rem",backgroundColor:"#09122C",borderRadius:"5px", lineHeight: "1.75", color: "white" }}>
                    {tabContent[activeTab]}
                </Box>
            </Card>
        </Box>
    );
}
